import { format, parseISO } from 'date-fns';
import { HeadType, RowType } from '@atlaskit/dynamic-table/dist/types/types';
import { AuditTrail } from '@css-xp/apd-common';
import { DATE_TIME_FORMAT } from '../../constants/table';

export const createTableHead = (): HeadType => {
  return {
    cells: [
      {
        key: 'date',
        content: 'Date',
        shouldTruncate: true,
        isSortable: true,
        width: 20,
        testId: 'date',
      },
      {
        key: 'update',
        content: 'Update',
        isSortable: true,
        shouldTruncate: true,
        width: 20,
        testId: 'update',
      },
      {
        key: 'actor',
        content: 'Made by',
        isSortable: true,
        shouldTruncate: true,
        width: 20,
        testId: 'actor',
      },

      {
        key: 'comments',
        content: 'Notes',
        isSortable: false,
        shouldTruncate: true,
        testId: 'comments',
      },
    ],
  };
};

export const createTableRows = (auditTrailList: AuditTrail[]): Array<RowType> => {
  return auditTrailList.map((item: any, index: number) => {
    const date = item.time ? parseISO(item.time) : '';
    return {
      key: `row-${index}-${date}`,
      cells: [
        {
          key: 'date' + index,
          content: date ? format(date, DATE_TIME_FORMAT) : '',
        },
        {
          key: 'update' + index,
          content: item.context ?? '',
        },
        {
          key: 'actor' + index,
          content: item.actor ?? '',
        },
        {
          key: 'comments' + index,
          content: item.comments ?? '',
        },
      ],
    };
  });
};
